// This is a skeleton starter React page generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {GetServerSidePropsContext} from "next";
import {useRouter} from "next/router";

import {PageParamsProvider as PageParamsProvider__} from "@plasmicapp/react-web/lib/host";

import PlasmicSplitsProvider from "@/components/plasmic/fb_rerum/PlasmicSplitsProvider";
import {PlasmicHomepage} from "@/components/plasmic/fb_rerum/PlasmicHomepage";

import {CommonPageProps, handlePageRequest} from "@lg-plus/landing-components";

import {makeSrvLgApiConnector} from "@lg-plus/landing-modules";

/**
 * Next.js will call this function at request time, on the server side.
 * Here we can securely call any private APIs, access a database, or
 * read from the filesystem.
 *
 * The returned props will be passed to the page component for rendering.
 */
export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    return handlePageRequest(ctx, async ({initialPayload, ...common}) => {
        const lgApiConn = makeSrvLgApiConnector();
        //TODO: should we ignore the session token here?
        return lgApiConn.triggerLanded(initialPayload || "", common);
    });
}

function Homepage({traits}: CommonPageProps) {
    // Use PlasmicHomepage to render this component as it was
    // designed in Plasmic, by activating the appropriate variants,
    // attaching the appropriate event handlers, etc.  You
    // can also install whatever React hooks you need here to manage state or
    // fetch data.
    //
    // Props you can pass into PlasmicHomepage are:
    // 1. Variants you want to activate,
    // 2. Contents for slots you want to fill,
    // 3. Overrides for any named node in the component to attach behavior and data,
    // 4. Props to set on the root node.
    //
    // By default, PlasmicHomepage is wrapped by your project's global
    // variant context providers. These wrappers may be moved to
    // Next.js Custom App component
    // (https://nextjs.org/docs/advanced-features/custom-app).

    return (
        <PageParamsProvider__
            route={useRouter()?.pathname}
            params={useRouter()?.query}
            query={useRouter()?.query}
        >
            <PlasmicSplitsProvider traits={traits}>
                <PlasmicHomepage />
            </PlasmicSplitsProvider>
        </PageParamsProvider__>
    );
}

export default Homepage;
